<script>
import {ShipBuilderService} from "@/services/ShipBuilderService";
import Swal from 'sweetalert2';
import {AlertService} from "@/services/AlertService";
import $ from "jquery";
export default {
  name: "SettingsShipBuilder",

  data(){
    return {
      ship_builders: [],
      currentPage: 1,
      perPage: 10,
      perPageOptions: [5, 10, 25, 50],
      searchQuery: "",
      form: {
        ship_builder_name: '',
      },
      originalShipBuilderName: "",
      editShipBuilderID: null,
      deleteShipBuilderID: null,
      deletePassword: null,
    }
  },
  computed:{
    filteredShipBuilders() {
      if (!this.searchQuery) return this.ship_builders;
      const q = this.searchQuery.toLowerCase();
      return this.ship_builders.filter((i) => {
        const name = (i.ship_builder_name || '').toLowerCase();
        return name.includes(q);
      });
    },
    paginatedShipBuilders() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredShipBuilders.slice(start, end);
    },
    totalPages() {
      const pages = Math.ceil(this.filteredShipBuilders.length / this.perPage);
      return Math.max(1, pages);
    },
    isUnchanged() {
      return this.form.ship_builder_name === this.originalShipBuilderName;
    },
  },
  methods:{
    showToast(icon, title) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon,
        title,
        showConfirmButton: false,
        timer: 2000,
      });
    },
    showAlert(icon, title, text = "", showCancel = false) {
      return Swal.fire({
        icon,
        title,
        text,
        showConfirmButton: true,
        confirmButtonColor: "#42b983",
        showCancelButton: showCancel,
        allowEscapeKey: false,
        allowOutsideClick: false,
        allowEnterKey: true,
        confirmButtonText: "OK",
      });
    },

    loadingModal() {
      Swal.fire({
        title: "Loading...",
        text: "Please wait",
        icon: "info",
        showCancelButton: false,
        showConfirmButton: false,
        allowEnterKey: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },

    openModal(type, data){
      if(type === 'add'){
        $("#createModal").modal("show");
      }
      else if(type === 'edit'){
        $("#updateModal").modal("show");
        this.form.ship_builder_name = data.ship_builder_name;
        this.editShipBuilderID = data.id;
        this.originalShipBuilderName = data.ship_builder_name;
      }
      else{
        $("#deleteModal").modal("show");
        this.deleteShipBuilderID = data.id;
      }
    },

    closeModal(type){
      this.form.ship_builder_name = '';
      if(type === 'add'){
        $("#createModal").modal("hide");
      }
      else if(type === 'edit'){
        $("#updateModal").modal("hide");
        this.editShipBuilderID = null;
        this.originalShipBuilderName = null;
      }
      else{
        $("#deleteModal").modal("hide");
        this.deleteShipBuilderID = null;
        this.deletePassword = null;
      }
    },

    cancelModal(type){
      if(type === 'add'){
        this.showAlert('warning','Cancel Add Ship Builder', 'Are you sure you want to cancel? Any information you entered will not be saved.', true).then((result) => {
          if (result.isConfirmed) {
            $("#createModal").modal("hide");
            this.form.ship_builder_name = null;
            this.showAlert("error", "Add Ship Builder Cancelled!");
          }
        });
      }
      else if(type === 'edit'){
        this.showAlert('warning','Cancel Edit Ship Builder', 'Are you sure you want to cancel? Any information you entered will not be saved.', true).then((result) => {
          if (result.isConfirmed) {
            $("#updateModal").modal("hide");
            this.editShipBuilderID = null;
            this.originalShipBuilderName = null;
            this.form.ship_builder_name = null;
            this.showAlert("error", "Edit Ship Builder Cancelled!");
          }
        });
      }
      else{
        this.showAlert('warning','Cancel Delete Ship Builder', 'Are you sure you want to cancel? Any information you entered will not be saved.', true).then((result) => {
          if (result.isConfirmed) {
            $("#deleteModal").modal("hide");
            this.deletePassword = null;
            this.deleteShipBuilderID = null;
            this.form.ship_builder_name = null;
            this.showAlert("error", "Delete Ship Builder Cancelled!");
          }
        });
      }

    },

    async fetchAllShipBuilders(){
      const response = await ShipBuilderService.getAllShipBuilders();
      this.ship_builders = response.data;
    },

    async createShipBuilder() {
      try {
        if(!this.form.ship_builder_name){
          this.showAlert("error", "Ship builder name is required!");
        }
        else if(this.form.ship_builder_name.length < 2){
          this.showAlert("error", "Ship builder name must have at least 2 characters!");
        }
        else{
          const result = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to add this ship builder?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#42b983",
            confirmButtonText: "Yes, please proceed!",
            cancelButtonText: "No, cancel!",
          });

          if (result.isConfirmed) {
            this.loadingModal();
            this.form.ship_builder_name = this.form.ship_builder_name.toUpperCase();

            try {
              const response = await ShipBuilderService.create(this.form);

              if (response.data.message === "Ship builder already exists") {
                this.showAlert("warning", "Duplicate Found!", "This ship builder already exists.");
              } else {
                this.showAlert("success", "Ship builder added!", "A new ship builder has been added to the list.");
                this.closeModal("add");
                await this.fetchAllShipBuilders();
              }
            } catch (error) {
              if (error.response && error.response.data.message === "Ship builder already exists") {
                this.showAlert("warning", "Duplicate Found!", "This ship builder already exists.");
              } else {
                this.showAlert("error", "Failed to create");
              }
            }
          } else {
            this.showAlert("info", "Creation cancelled");
          }
        }
      } catch {
        this.showAlert("error", "Something went wrong");
      }
    },

    async updateShipBuilder() {
      try {
        if(!this.form.ship_builder_name){
          this.showAlert("error", "Ship builder name is required!");
        }
        else if(this.form.ship_builder_name.length < 2){
          this.showAlert("error", "Ship builder name must have at least 2 characters!");
        }
        else{
          const result = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to update this ship builder?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#42b983",
            confirmButtonText: "Yes, please proceed!",
            cancelButtonText: "No, cancel!",
          });

          if (result.isConfirmed) {
            this.loadingModal();
            this.form.ship_builder_name = this.form.ship_builder_name.toUpperCase();

            try {
              const response = await ShipBuilderService.update(this.editShipBuilderID, this.form);

              this.showAlert("success", "Ship builder updated!", "The ship builder was successfully updated.");
              this.closeModal("edit");
              await this.fetchAllShipBuilders();

            } catch (error) {
              if (error.response && error.response.status === 409) {
                this.showAlert("warning", "Duplicate Found!", "This ship builder already exists.");
              } else {
                this.showAlert("error", "Failed to update");
              }
            }
          }
        }
      } catch {
        this.showAlert("error", "Failed to update");
      }
    },

    async deleteShipBuilder() {
      try {
        this.loadingModal();
        await ShipBuilderService.deleteWithPassword(this.deleteShipBuilderID, this.deletePassword);
        this.showAlert("success", "Ship builder deleted!");
        this.closeModal('delete');
        await this.fetchAllShipBuilders();
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.showAlert("error", "Incorrect Password" ,"Please check if the password you entered is correct before submitting.");
        } else {
          AlertService.errorAlert('Failed to delete ship builder', 'ERROR');
        }
      }
    },
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
    },
    perPage() {
      this.currentPage = 1;
    },
    filteredShipBuilders() {
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }
    },
  },
  async created(){
    await this.fetchAllShipBuilders();
  },
}
</script>

<template>
 <div>
   <div class="row">
     <div class="col-12 pl-3 pr-3 pt-2">
       <h3 class="text-uppercase e-text-red font-weight-bold">Ship Builder</h3>
     </div>
   </div>
   <hr class="border border-secondary border-3" style="z-index: -1; opacity: 0.4;">
   <div class="row">
     <div class="col-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="row">
              <div class="col-6 d-flex justify-content-center align-items-center">
                <input
                  v-model="searchQuery"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Search"
                />
              </div>
              <div class="col-6 d-flex justify-content-end align-items-center">
                <button class="e-btn e-btn-green e-text-white" @click="openModal('add')">
                  <font-awesome-icon icon="plus-square" style="width: 25px" />
                  <small class="font-weight-bold text-uppercase">Add Ship Builder</small>
                </button>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-6">
                <label>
                  Show
                  <select v-model="perPage" class="form-control form-control-sm d-inline-block w-auto ml-2">
                    <option v-for="n in perPageOptions" :key="n" :value="n">{{ n }}</option>
                  </select>
                  entries
                </label>
              </div>
              <div class="col-md-6 text-right">
                <nav>
                  <ul class="pagination pagination-sm justify-content-end mb-0">
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                      <button class="page-link" @click="currentPage--" :disabled="currentPage === 1">
                        Previous
                      </button>
                    </li>

                    <li
                      v-for="page in totalPages"
                      :key="page"
                      class="page-item"
                      :class="{ active: currentPage === page }"
                    >
                      <button class="page-link" @click="currentPage = page">{{ page }}</button>
                    </li>

                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                      <button
                        class="page-link"
                        @click="currentPage++"
                        :disabled="currentPage === totalPages"
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-uppercase font-weight-bold text-center" style="color: black; width: 5%;">#</th>
                      <th class="text-uppercase font-weight-bold text-center" style="color: black;">Name</th>
                      <th class="text-uppercase font-weight-bold text-center" style="color: black;">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(data, index) in paginatedShipBuilders" :key="index">
                    <td class="text-center align-middle" style="color: black">{{ (currentPage - 1) * perPage + index + 1 }}</td>
                    <td class="text-center align-middle" style="color: black">{{ data.ship_builder_name }}</td>
                    <td class="text-center align-middle">
                      <div class="btn-group dropleft">
                        <button class="mr-2 btn btn-sm btn-secondary force-white-all" data-toggle="dropdown">
                          <font-awesome-icon icon="cogs" />
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <button class="dropdown-item text-secondary font-weight-bolder" @click="openModal('edit',data)">
                            <font-awesome-icon icon="pen" /> &nbsp;Update
                          </button>
                          <button class="dropdown-item text-danger font-weight-bolder" @click="openModal('delete',data)">
                            <font-awesome-icon icon="trash" class="force-danger-all" />  &nbsp;Delete
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-sm-12 text-right">
                <small style="color: black" class="text-uppercase">
                  Showing
                  <strong>{{ (currentPage - 1) * perPage + 1 }}</strong>
                  to
                  <strong>{{ Math.min(currentPage * perPage, filteredShipBuilders.length) }}</strong>
                  of
                  <strong>{{ filteredShipBuilders.length }}</strong>
                  entries
                </small>
              </div>
            </div>
          </div>
        </div>
     </div>

     <!-- Create Modal -->
     <div
       class="modal fade"
       id="createModal"
       tabindex="-1"
       role="dialog"
       aria-labelledby="createModalLabel"
       aria-hidden="true"
     >
       <div class="modal-dialog modal-dialog-centered" role="document">
         <div class="modal-content">
           <form @submit.prevent="createShipBuilder">
             <div class="modal-header">
               <h5 class="modal-title" id="createModalLabel">
                 Add Ship Builder
               </h5>
               <button
                 type="button"
                 class="close"
                 @click="cancelModal('add')"
               >
                 <span aria-hidden="true">&times;</span>
               </button>
             </div>
             <div class="modal-body">
               <div class="form-group">
                 <label class="">Name <small class="text-danger font-weight-bold" style="font-style: italic;">(required)</small></label>
                 <input v-model="form.ship_builder_name" class="form-control form-control-sm"/>
               </div>
             </div>
             <div class="modal-footer">
               <button type="submit" class="btn btn-primary btn-sm">Save</button>
             </div>
           </form>
         </div>
       </div>
     </div>

     <!-- Update Modal -->
     <div
       class="modal fade"
       id="updateModal"
       tabindex="-1"
       role="dialog"
       aria-labelledby="updateModalLabel"
       aria-hidden="true"
     >
       <div class="modal-dialog modal-dialog-centered" role="document">
         <div class="modal-content">
           <form @submit.prevent="updateShipBuilder">
             <div class="modal-header">
               <h5 class="modal-title" id="updateModalLabel">
                 Edit Ship Builder
               </h5>
               <button
                 type="button"
                 class="close"
                 @click="cancelModal('edit')"
               >
                 <span aria-hidden="true">&times;</span>
               </button>
             </div>
             <div class="modal-body">
               <div class="form-group">
                 <input v-model="form.ship_builder_name" class="form-control form-control-sm" @input="form.ship_builder_name = form.ship_builder_name.toUpperCase()"/>
               </div>
             </div>
             <div class="modal-footer">
               <button type="submit" class="btn btn-primary btn-sm" :disabled="isUnchanged || !form.ship_builder_name">Save</button>
             </div>
           </form>
         </div>
       </div>
     </div>

     <!-- Delete Modal -->
     <div
       class="modal fade"
       id="deleteModal"
       tabindex="-1"
       role="dialog"
       aria-labelledby="deleteModalLabel"
       aria-hidden="true"
     >
       <div class="modal-dialog modal-dialog-centered" role="document">
         <div class="modal-content">
           <form @submit.prevent="deleteShipBuilder">
             <div class="modal-header">
               <h5 class="modal-title text-uppercase font-weight-bold">Delete Ship Builder</h5>
               <button type="button" class="close" @click="cancelModal('delete')">
                 <span>&times;</span>
               </button>
             </div>
             <div class="modal-body">
               <div class="text-center mb-3">
                 <h5 class="text-uppercase font-weight-bold">Are you sure you want to delete this ship builder?</h5>
               </div>
               <div class="form-group">
                 <label class="font-weight-bold">Enter your password to confirm:</label>
                 <input v-model="deletePassword" class="form-control form-control-sm" type="password"/>
               </div>
             </div>
             <div class="modal-footer">
               <button type="submit" class="btn btn-primary btn-sm" v-if="deletePassword">Proceed</button>
               <button type="submit" class="btn btn-primary btn-sm" v-else disabled>Proceed</button>
             </div>
           </form>
         </div>
       </div>
     </div>

   </div>
 </div>
</template>

<style scoped>

</style>
